<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4>
                    {{ $t('org.billing.Region') }} + {{ $t('org.billing.Product') }} + {{ $t('org.billing.Category') }} & {{ $t('org.billing.ItemDescription') }}
                </h4>
            </div>
        </div>
        <div class="b-table-sticky-header table-responsive" style="max-height:900px">
            <b-table-simple>
                <b-thead>
                    <b-tr>
                        <b-th>
                            {{ $t('v4.Region') }}
                        </b-th>
                        <b-th>
                            {{ $t('v4.Product') }}
                        </b-th>
                        <b-th>
                            {{ $t('v4.Category') }}
                        </b-th>
                        <b-th>
                            {{ $t('v4.Cost') }}
                        </b-th>
                    </b-tr>
                </b-thead>
                <b-tbody v-if="noData">
                    <b-tr>
                        <b-td
                            colspan="4"
                            class="pb-50 pt-2 text-center"
                        >
                            {{ $t("org.message.No Data") }}
                        </b-td>
                    </b-tr>
                </b-tbody>
                <b-tbody v-else>
                    <template v-for="(item, index) in data">
                        <b-tr :key="index">
                            <b-td :rowspan="rowspanMaps[item.key].count + 1">
                                {{ item.key }}
                                <span class="pull-right">
                                    {{ $_getDollar(item.cost) }}
                                </span>
                            </b-td>
                        </b-tr>
                        <template v-for="(productCode, index) in item.productCodes.slice(0, item.productCodes.length)">
                            <b-tr :key="`${item.key}-${productCode.key}-${index}`">
                                <b-td :rowspan="productCode.productCategories.length + 1">
                                    {{ productCode.key }}
                                    <span class="pull-right">
                                        {{ $_getDollar(productCode.cost) }}
                                    </span>
                                </b-td>
                            </b-tr>
                            <b-tr v-for="(productCategory, index) in productCode.productCategories.slice(0, productCode.productCategories.length)" :key="`${item.key}-${productCode.key}-${productCategory.key}-${index}`">
                                <b-td>
                                    {{ productCategory.key }}
                                </b-td>
                                <b-td class="text-right text-nowrap">
                                    <a href="javascript:;" @click="getDescription({ region: item.key, productCode: productCode.key, productCategory: productCategory.key })">
                                        {{ $_getDollar(productCategory.cost) }}
                                    </a>
                                </b-td>
                            </b-tr>
                        </template>
                    </template>
                </b-tbody>
            </b-table-simple>
        </div>
        <b-modal
            ref="DYNAMICSEARCH_DETAIL_MODAL"
            modalClass="modal-card-detail"
            ok-only
            :ok-title="$t('v4.Close')"
            size="lg"
            :title="modalTitle"
        >
            <div class="row" style="padding:3px 0;" v-for="(item, index) in itemDescription" :key="index">
                <div class="col-md-8">
                    {{ item.itemDescription }}
                </div>
                <div class="col-md-2 text-right">
                    x {{ $_getNumberFormat(item.usageAmount) }}
                </div>
                <div class="col-md-2 text-right">
                    <b>
                        {{ $_getDollar(item.cost) }}
                    </b>
                </div>
            </div>
        </b-modal>
    </b-card>
</template>

<script>
import { ref, toRefs, computed, watch } from '@vue/composition-api'
export default {
    props: {
        data: {
            type: Array,
            default: function () {
                return []
            }
        },
        themeColors: {
            type: Object,
            default: function () {
                return {}
            }
        },
        itemDescription: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    setup (props, context) {
        const { data, itemDescription } = toRefs(props)
        const DYNAMICSEARCH_DETAIL_MODAL = ref(null)
        const modalTitle = ref('')
        const noData = computed(() => !data.value.length)
        const rowspanMaps = computed(() => {
            return data.value.reduce((accumulator, currentValue) => {
                let count = 0
                currentValue.productCodes.forEach(item => {
                    count += item.productCategories.length + 1
                })
                accumulator[currentValue.key] = {
                    count
                }
                return accumulator
            }, {})
        })
        const getDescription = ({ region, productCode, productCategory }) => {
            modalTitle.value = `${region}, ${productCode}, ${productCategory}`
            context.emit('filter:description', {
                region: [region],
                productCode: [productCode],
                productCategory: [productCategory]
            })
        }
        const showDetailModal = () => {
            if (DYNAMICSEARCH_DETAIL_MODAL.value) {
                DYNAMICSEARCH_DETAIL_MODAL.value.show()
            }
        }
        watch(itemDescription, (value, oldValue) => {
            if (value) {
                showDetailModal()
            }
        })
        return {
            DYNAMICSEARCH_DETAIL_MODAL,
            modalTitle,
            noData,
            rowspanMaps,
            getDescription
        }
    }
}
</script>

<style>

</style>
